import { t } from '@trimble/i18n';
import { GaussianSplatItem } from '@mobile-mapping/providers';
import { TreeNodeDefinition } from '@trimble/ui-components/solidjs';
import pointCloudIcon from '../../assets/icons/point-cloud.svg';

export const GAUSSIAN_SPLAT_ROOT_NODE_ID = 'gaussianSplats';

export const buildGaussianSplatNodes = (
  items: GaussianSplatItem[]
): TreeNodeDefinition<GaussianSplatItem>[] => {
  const itemNodes = items.map(
    (item) =>
      ({
        id: item.id,
        label: item.name,
        data: item,
        parentId: GAUSSIAN_SPLAT_ROOT_NODE_ID,
        isLeaf: true,
        toggleTooltip: t(
          'mobileMapping.projectData.toggleGaussianSplatVisibility'
        ),
      }) satisfies TreeNodeDefinition<GaussianSplatItem>
  );

  if (itemNodes.length === 0) return [];

  return [
    {
      id: GAUSSIAN_SPLAT_ROOT_NODE_ID,
      label: t('mobileMapping.projectData.gaussianSplats'),
      labelSvgIcon: pointCloudIcon,
      isLeaf: false,
    },
    ...itemNodes,
  ];
};
